import { trackPageView } from "@/analytics/core";
import { paneTypeFor, routeNameFor } from "@/analytics/routeName";
import type { LocationState } from "@/types/pane-routing";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Pageviews carry the stable route name, never document.title — React 19
 * hoists user content (canvas/workspace/skill names) into <title>.
 * data-tracking-title remains an explicit, content-free override.
 *
 * The timeout keeps the historical ordering: it lets route-change effects
 * (including a data-tracking-title write) settle before the view is tracked.
 */
export function useTrackPageView() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const paneType = paneTypeFor(
      (location.state as LocationState | null)?.rightPane?.pathname,
    );

    const timeout = setTimeout(() => {
      const titleTag = document.getElementsByTagName("title")[0];
      const titleOverride = titleTag?.getAttribute("data-tracking-title");
      const routeName = routeNameFor(pathname);

      trackPageView({
        current_page_title: titleOverride || routeName,
        route_name: routeName,
        ...(paneType ? { pane_type: paneType } : {}),
      });
    }, 100);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
}
